const config = require('../config');

let language = config.LANGUAGES[0];

function setApiLanguage(newLanguage) {
  language = newLanguage;
}

function getApiLanguage() {
  return language;
}

module.exports = {
  setApiLanguage,
  getApiLanguage,
};
